import React from 'react';
import PropTypes from 'prop-types';
import {defineMessages, useIntl} from 'react-intl';
import classes from './redirect-uri-row.scss';
import { SubtractFilledIcon } from '@getgo/chameleon-icons/react';
import { Button, TextField } from '@getgo/chameleon-web-react-wrapper';
import { Box } from '@mui/material';

const t = defineMessages({
  'redirect.uri.row.delete.title': {
    id: 'redirect.uri.row.delete.title',
    defaultMessage: 'Delete {url}',
    description: 'Hover text for the delete row icon',
  },
});

const RedirectURIRow = ({
  position,
  redirectUri,
  uriCount,
  onDeleteUriClick,
  disabled = false,
}) => {
  const intl = useIntl();
  return (
    <Box className={classes['uriSingleRow']}>
      <Box
        className={`row no-margin ${classes['uriRow']}`}
        id={`redirectUri-${position}`}>
        <Box className="col-xs-2 text-right">
          <TextField
            name="redirectUriList"
            data-testid="redirectUriRow"
            label=""
            helpText=""
            value={redirectUri}
            role="textbox"
            readOnly
            fullwidth
					/>
        </Box>
      </Box>
      {uriCount > 0 && !disabled &&
        <Button
          className={classes["deleteUriButton"]}
          data-testid="deleteUriButton"
          variant="tertiary"
          onClick={onDeleteUriClick(position)}
          type="button"
          title={intl.formatMessage(t['redirect.uri.row.delete.title'], {url: redirectUri})}>
          <SubtractFilledIcon color="#2C72DE" />
        </Button>}
    </Box>
  );
};

RedirectURIRow.propTypes = {
  position: PropTypes.number.isRequired,
  redirectUri: PropTypes.string.isRequired,
  uriCount: PropTypes.number.isRequired,
  onDeleteUriClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default RedirectURIRow;
